var pad = require('./pad');

module.exports = function rpad(str, length, padStr) {
  return pad(str, length, padStr, 'right');
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore.string/rpad.js
// module id = 823
// module chunks = 0